module.exports = __webpack_public_path__ + "static/scientist11-1de859b5b72a64eed931fa507e7a9c40.jpg";